import type { ReactNode } from 'react';
import { ChevronRightIcon } from '@alchemiesolns/ui';

interface CollapsibleProps {
  title: string;
  icon?: ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
  contentId?: string;
  ariaLabel?: string;
}

export function Collapsible({
  title,
  icon,
  isOpen,
  onToggle,
  children,
  contentId,
  ariaLabel,
}: CollapsibleProps) {
  return (
    <div className="flex-col gap-2">
      <button
        type="button"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          cursor: 'pointer',
          userSelect: 'none',
          background: 'none',
          border: 'none',
          padding: 0,
          textAlign: 'left',
        }}
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        <ChevronRightIcon
          style={{
            transition: 'transform 0.2s',
            transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
          }}
        />
        {icon}
        <h4 className="text-sm font-medium text-gray-700" style={{ margin: 0 }}>
          {title}
        </h4>
      </button>
      {isOpen && (
        <div
          id={contentId}
          style={{
            marginTop: '0.5rem',
            transition: 'all 0.3s ease-in-out',
          }}
          role="region"
          aria-label={ariaLabel || title}
        >
          {children}
        </div>
      )}
    </div>
  );
}
